import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const TemaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TEMA' htmlFor='select-tema' md={2} />
      <Col md={10}>
        <Field name='tema'>
          {({ field }) => <Form.InputText {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-tema' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TemaFormGroup)
